module.exports = __webpack_public_path__ + "assets/img/chevron-down-white.874548f1.svg";